/**
 * Configuración paginaciones app.
 *
 * @readonly
 * @enum {number}
 */
const PAGE_SIZE = {
  ARCHIVOS_ADJUNTOS: 5,
  PERSONAS_IMPLICADAS: 5,
  LISTADO_ASIGNAR_DENUNCIA: 5,
  LISTADO_DENUNCIAS: 15,
  LISTADO_DENUNCIAS_SELECCIONADAS: 5,
  LISTADO_GESTION_DENUNCIAS: 5,
  LISTADO_USUARIOS: 15,
};

/**
 * Tamaño maximo de audio 20MB
 *
 * @readonly
 */
const MAX_AUDIO_SIZE = 20971520; // 20MB

/**
 * Tamaño maximo de archivo 25MB
 *
 * @readonly
 */
const MAX_FILE_SIZE = 26214400; // 25MB

/**
 * Tamaño maximo de imagen 25KB
 *
 * @readonly
 */
const MAX_IMAGE_SIZE = 512000; // 500KB

/**
 * Tamaño maximo de textArea
 *
 * @readonly
 */
const MAX_TEXT_AREA = 150;

const POLICY_NAMES = {
  INFORMATION: 'politica-informacion.pdf',
  COOKIES: 'politica-cookies.pdf',
  PRIVACY: 'politica-privacidad.pdf',
};

const MANUAL_NAME = 'manual-usuario.pdf';

export { MANUAL_NAME, MAX_AUDIO_SIZE, MAX_FILE_SIZE, MAX_TEXT_AREA, PAGE_SIZE, POLICY_NAMES, MAX_IMAGE_SIZE };
